// extracted by mini-css-extract-plugin
export var arrows = "_1j-6";
export var decrementer = "_1j-a";
export var disabled = "_1j-4";
export var error = "_1j-1";
export var hiddenText = "_1j-b";
export var incrementer = "_1j-9";
export var input = "_1j-8";
export var inputWrapper = "_1j-0";
export var leadingIcon = "_1j-c";
export var readonly = "_1j-3";
export var regular = "_1j-7";
export var small = "_1j-5";
export var warning = "_1j-2";